import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import MapComponent from './components/map/MapComponent';

function App() {
  return (
    <Router>
      <div className="App">
        <MapComponent />
      </div>
    </Router>
  );
}

export default App;
